
















































import { Component, Vue } from 'vue-property-decorator';
import authModule from '@/store/Auth';

@Component({
  components: {},
})
export default class SubscribedOnlyWarning extends Vue {
  get activeOrganisation() {
    if (!authModule.activeOrganisation) {
      throw new Error(
        this.$t('common.alerts.missingActiveOrganisation') as string,
      );
    }
    return authModule.activeOrganisation.organisation;
  }

  get isOwner() {
    return authModule.isOwner;
  }

  get isActive() {
    return this.activeOrganisation && this.activeOrganisation.isActive;
  }
}
